export default __webpack_public_path__ + "static/media/manwithpig.fe6d88fd.svg";